import { SimpleTask } from 'aos-services/src/services/tasks/types/task/SimpleTask'
import { TaskTemplate } from 'aos-services/src/services/tasks/types/task/TaskTemplate'
import { TFunction } from 'i18next'

import type { PropsListEntry } from '../PropsListEntry'

export const simpleTaskPropertyList =
    (_: TFunction) =>
    (_: SimpleTask | TaskTemplate<SimpleTask>): PropsListEntry[] => []
